import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit/modal';
import { Button, RadioGroup } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IReasonModalProps {
  isOpen: boolean;
  close(): void;
  disableForms(answers: string[]): void;
}

const reasons = [
  {
    label: 'С ними дольше искать',
    value: 'С ними дольше искать',
  },
  {
    label: 'Хочу, чтобы мне звонили',
    value: 'Хочу, чтобы мне звонили',
  },
  {
    label: 'Получаю мало анкет',
    value: 'Получаю мало анкет',
  },
  {
    label: 'Мне неудобно изучать анкеты',
    value: 'Мне неудобно изучать анкеты',
  },
  {
    label: 'Арендаторам неудобно',
    value: 'Арендаторам неудобно',
  },
];

export const DisableFormsPollModal: React.FC<IReasonModalProps> = ({ isOpen, close, disableForms }) => {
  const [reason, setReason] = React.useState<string | undefined>(undefined);

  const onReasonChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setReason(value);
  }, []);

  const reject = React.useCallback(() => {
    disableForms([String(reason)]);
  }, [reason, disableForms]);

  return (
    <ModalWindow
      title="Почему хотите отключить анкеты?"
      content={<RadioGroup name="reason" onChange={onReasonChange} options={reasons} value={reason} />}
      footer={
        <div className={styles['footer']}>
          <Button onClick={reject} size="XS">
            Отключить анкеты
          </Button>
        </div>
      }
      escape
      fixed={false}
      onClose={close}
      outside
      size="M"
      open={isOpen}
      maxWidth={628}
    />
  );
};
